import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as contactUsService from "../../services/contact-us.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  formateDateWithMonth,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import Swal from "sweetalert2";
import { showFilterList, SWAL_SETTINGS, THEME_COLORS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import { useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const InquiryTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState(false);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({ column: "createdAt", order: "descending" });
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [searchParams] = useSearchParams();

  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({
    ...(searchParams.get("status") ? { status: searchParams.get("status") } : {}),
  });

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Contact Us", url: "" },
  ];
  const showInquiryFilterList = [
    { name: "Status", status__id: "" },
    { name: "Pending", status__id: "PENDING" },
    { name: "Resolved", status__id: "RESOLVED" },
    { name: "Spam", status__id: "SPAM" },
  ];

  useEffect(() => {
    if (params.pgno) {
      setPage(Number(params.pgno));
    }
  }, [params.pgno]);

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const paramsData = {
        limit: itemperpage,
        page: params.pgno ? Number(params.pgno) : 1,
        sorting: JSON.stringify(sorting),
        filters: JSON.stringify(search),
        global_search: globalsearch
      };
      
      contactUsService.List(paramsData)
        .then((response) => {
          if (response.success) {
            setList(response.data.list || []);
            setDataLength(response.data.total_records !== undefined ? response.data.total_records : (response.data.list ? response.data.list.length : 0));
            setLoader(false);
          }
        })
        .catch((error) => {
          console.error("List error:", error);
          setLoader(false);
        });
    }, 300);
    return () => clearTimeout(getData)
  }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);


  const viewfunction = (row) => {
    navigate(`/admin/contact-us/view/${row.id}`);
  };

  const markResolve = (row, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: "You want to change the status of this inquiry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: "Yes, change it!",
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        contactUsService.StatusChange(row.id, { status })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.error("Status change error:", error);
          });
      }
    });
  }




  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function

  const prepareFilter = (key, value) => {

    console.log('key---', key, value)
    const statusLabelMap = {
      "New": "new",
      "Responded": "responded",
      "In Progress": "in_progress",
      "Closed": "closed",
    };

    let sr;

    if (statusLabelMap[value]) {
      sr = { "status": statusLabelMap[value] };
    }

    else {
      sr = { ...search };
      if (String(value).length > 0) {
        sr[key] = value;
      } else {
        delete sr[key];
      }
    }

    if (value && typeof value === "string" && value.toLowerCase() === "status") {
      sr = {};
    }




    console.log('sr---', sr)
    setSearch(sr);
  };


  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareFilter();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  const exportPDF = () => {
    setLoader(true);
    const paramsData = {
      limit: itemperpage,
      sorting: JSON.stringify(sorting),
      filters: JSON.stringify(search),
      global_search: globalsearch
    };

    contactUsService.List(paramsData)
      .then((response) => {
        if (response.success) {
          const exportData = response.data.list || [];
          const doc = new jsPDF();
          
          doc.setFontSize(22);
          doc.setTextColor(32, 128, 120); 
          doc.text("mNetrics", 14, 20);
          
          doc.setFontSize(14);
          doc.setTextColor(44, 42, 99); 
          doc.text("Contact Us Inquiries", 14, 30);

          doc.setFontSize(9);
          doc.setTextColor(100);
          doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 37);

          const tableColumn = ["Sr. No", "Status", "Name", "Email", "Platform", "Subject", "Inquiry Date"];
          const tableRows = [];

          exportData.forEach((row, index) => {
            const rowData = [
              ((page - 1) * itemperpage) + index + 1,
              row.status || "N/A",
              row.name || "N/A",
              row.email || "N/A",
              row.platform || "Website",
              row.subject || "N/A",
              row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
            ];
            tableRows.push(rowData);
          });

          autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 45,
            theme: 'striped',
            headStyles: { fillColor: [32, 128, 120], fontSize: 9, fontStyle: 'bold' },
            styles: { fontSize: 8, cellPadding: 2.5 },
            alternateRowStyles: { fillColor: [248, 252, 251] },
          });

          doc.save(`Inquiries_${new Date().getTime()}.pdf`);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Export error:", error);
        setLoader(false);
      });
  };

  const exportCSV = () => {
    setLoader(true);
    const paramsData = {
      limit: itemperpage,
      sorting: JSON.stringify(sorting),
      filters: JSON.stringify(search),
      global_search: globalsearch
    };

    contactUsService.List(paramsData)
      .then((response) => {
        if (response.success) {
          const exportData = response.data.list || [];
          const headers = ["Sr. No", "Status", "Name", "Email", "Platform", "Subject", "Inquiry Date"];
          const csvContent = [
            headers.join(","),
            ...exportData.map((row, index) => {
              const rowData = [
                ((page - 1) * itemperpage) + index + 1,
                row.status || "N/A",
                `"${(row.name || "N/A").replace(/"/g, '""')}"`,
                `"${(row.email || "N/A").replace(/"/g, '""')}"`,
                `"${(row.platform || "Website").replace(/"/g, '""')}"`,
                `"${(row.subject || "N/A").replace(/"/g, '""')}"`,
                row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
              ];
              return rowData.join(",");
            })
          ].join("\n");

          const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `Inquiries_${new Date().getTime()}.csv`);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Export error:", error);
        setLoader(false);
      });
  };

  // const goToEdit = (row) => {
  //   navigate(
  //     `/admin/testimonial-management/testimonial/${params.pgno}/edit/${row._id}`
  //   );
  // };

  const Deletefunction = (row) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        contactUsService.Delete(row.id).then(response => {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })
            setStatusUpdate(!statsupdate)
          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.error("Delete error", error)
        });
      }
    })
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("sidebar_link_inquiries")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareFilter("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareFilter={prepareFilter}
                    selectedStatus={search?.status || ""}
                  />
                </div>

                <button
                  type="button"
                  onClick={exportPDF}
                  className="btn ripple btn-secondary signbtn me-2"
                  disabled={loader}
                >
                  <i className="ri-file-pdf-line me-1"></i> Export PDF
                </button>
                <button
                  type="button"
                  onClick={exportCSV}
                  className="btn ripple btn-info signbtn me-3"
                  disabled={loader}
                >
                  <i className="ri-file-excel-line me-1"></i> Export CSV
                </button>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>


                        <th className="status_head">{t("list_heading_status")}</th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="name"
                            />
                          </div>
                        </th>




                        <th>
                          <div className="sorting_column">
                            <span>{t("label_email")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="email"
                            />
                          </div>
                        </th>



                        <th>
                          <div className="rating_head">
                            <span>{t("label_platform")}</span>
                          </div>
                        </th>


                        <th>
                          <div className="rating_head">
                            <span>{t("label_subject")}</span>
                          </div>
                        </th>

                        {/* <th className="status_head">SUBSCRIBE</th> */}
                        <th className="created_head">
                          <div className="sorting_column">
                            <span>{t("label_inquiry_date")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="createdAt"
                            />
                          </div>
                        </th>

                        <th className="action_head">{t("list_heading_action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >

                                <td>
                                  {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                </td>


                                <td>
                                  <div className="btn-group mlAction">
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>
                                          {t("label_change_inquiry_status")}
                                        </Tooltip>
                                      }
                                    >
                                      <span className="dropdown-toggle no-after" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i
                                          className="ri-settings-5-fill me-1"
                                          style={{
                                            color: "#000000",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                            marginLeft: "6px",
                                          }}
                                        ></i>
                                      </span>
                                    </Whisper>

                                    <ul className="dropdown-menu">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, "PENDING");
                                          }}
                                        >
                                          Pending
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, "RESOLVED");
                                          }}
                                        >
                                          Resolved
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, "SPAM");
                                          }}
                                        >
                                          Spam
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                  {(() => {
                                    if (row.status === "PENDING") {
                                      return <span className="badge badge-pill badge-primary-light">Pending</span>
                                    } else if (row.status === "RESOLVED") {
                                      return <span className="badge badge-pill badge-success-light">Resolved</span>
                                    } else if (row.status === "SPAM") {
                                      return <span className="badge badge-pill badge-danger-light">Spam</span>
                                    } else {
                                      return <span className="badge badge-pill badge-info-light">{row.status}</span>
                                    }
                                  })()}
                                </td>

                                <td>
                                  {row?.name ? (
                                    <div className="d-flex">
                                      {row?.name ? TrimText(row.name, 50) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>




                                <td>
                                  {row?.email ? (
                                    <div className="d-flex">{TrimText(row.email, 50)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>



                                <td>
                                  <div className="d-flex">Website</div>
                                </td>

                                <td>
                                  {row?.subject ? (
                                    <div className="d-flex">{TrimText(row.subject, 35)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row.createdAt
                                    ? formateDateWithMonth(row.createdAt)
                                    : "N/A"}
                                </td>


                                <td>
                                  <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                        <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                          <i className="ri-eye-fill"></i>
                                        </button>
                                      </Whisper>
                                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                        <button type="button" className="btn delete" onClick={() => { Deletefunction(row) }}>
                                          <i className="ri-delete-bin-6-fill"></i>
                                        </button>
                                      </Whisper>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Contact Us",
                        path: "/admin/contact-us/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default InquiryTable;
